import { createContext } from 'react'

// Lets AuditGroupNode toggle a group's collapsed state without threading a
// callback through the pure layout in auditLayout.ts.
export const AuditToggleContext = createContext<(groupKey: string) => void>(
  () => {
    /* default no-op; real handler provided by AuditFlow */
  },
)

// A request to open the reference-data grid filtered to one node's value.
export type ReferenceLink = {
  object?: string // fallback object; the mapping fetch resolves the true type
  tenantSide: 'origin' | 'destination' | 'master'
  sourceId?: string // origin/destination: filter by source id
  mappingId?: string // origin/destination: fetch the mapping to read its type
  goid?: string // master: filter the entity grid by goid
}

// Lets AuditNode deep-link into the reference-data grid (handled by AuditFlow,
// which has router + tenant access) without threading a callback through layout.
export const AuditNavContext = createContext<(link: ReferenceLink) => void>(
  () => {
    /* default no-op; real handler provided by AuditFlow */
  },
)
